import React, { FC } from 'react';
import { Badge } from 'reactstrap';
import { ProductModel } from '../../shared/orders';
import { AgeRestrictedProductBadge } from '.';

interface ProductBadgesProps {
  readonly product: ProductModel;
  readonly includeCategory?: boolean;
  readonly float?: boolean;
}

export const ProductBadges: FC<ProductBadgesProps> = ({ float, includeCategory, product }) => {
  const idPrefix = `product${product.id}Info`;

  return (
    <div className="badge-list compact" style={{ float: float ? 'right' : 'none' }}>
      {includeCategory && (
        <Badge color="info" id={`${idPrefix}Category`} pill>
          {product.category.name}
        </Badge>
      )}
      {product.minAge || product.maxAge ? (
        <AgeRestrictedProductBadge
          idPrefix={idPrefix}
          maxAge={product.maxAge}
          minAge={product.minAge}
        />
      ) : null}
    </div>
  );
};
